export const socketDisconnectedError = route =>
	Object.assign(new Error(`socket disconnected before ${route}`), { disconnected: true });

// socket.io buffers emits while disconnected and sends them on reconnect, after the caller has
// already reported failure. eca-websockets acks with { data } on success or { error } on failure.
export const emitWithAck = async (socket, timeoutMs, route, ...args) => {
	if (!socket.connected) throw socketDisconnectedError(route);
	let response;
	try {
		response = await socket.timeout(timeoutMs).emitWithAck(route, ...args);
	} catch {
		throw Object.assign(new Error(`${route} was not acknowledged`), { timedOut: true });
	}
	if (response.error) throw response.error;
	return response.data;
};
